import React from 'react'

const HeroAsset = (props) => {
  return (
    <svg
      width="436"
      height="527"
      viewBox="0 0 436 527"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      {...props}
    >
      <rect
        x="218.018"
        y="77.1523"
        width="133.855"
        height="197.994"
        fill="#0185A2"
      />
      <path
        d="M217.085 77.1525L109.258 0H243.577L351.87 77.1525H217.085Z"
        fill="#61C9D7"
      />
      <path
        d="M329.821 372.749C329.821 457.456 261.361 526.124 176.911 526.124C92.4604 526.124 24 457.456 24 372.749C24 372.749 92.4604 372.749 176.911 372.749C261.361 372.749 329.821 372.749 329.821 372.749Z"
        fill="#5CEBA0"
      />
      <path
        d="M109.446 0L0.501953 77.0275V235.176H218.016V77.0275L109.446 0Z"
        fill="#393E42"
      />
      <path
        d="M251.031 14L233 26.7737V53H269V26.7737L251.031 14Z"
        fill="#0185A2"
      />
      <g filter="url(#filter0_d_6561_15473)">
        <path
          d="M350.945 235.176L218.018 139.432H286.694L420.194 235.176H350.945Z"
          fill="#FD7A7D"
        />
        <rect
          x="351.873"
          y="235.176"
          width="68.7865"
          height="197.994"
          fill="#E9EBEC"
        />
        <g filter="url(#filter1_d_6561_15473)">
          <path
            d="M235.062 247.657H179.781V191.598H235.062V247.657Z"
            fill="#1D1F21"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M218.321 139.432L84.1641 235.641V432.963H351.874V235.176L218.321 139.432ZM118.982 418.107C124.366 418.107 128.731 413.742 128.731 408.358C128.731 402.973 124.366 398.608 118.982 398.608C113.597 398.608 109.232 402.973 109.232 408.358C109.232 413.742 113.597 418.107 118.982 418.107ZM109.236 334.074C109.236 328.69 113.601 324.325 118.986 324.325C124.371 324.325 128.736 328.69 128.736 334.074C128.736 339.459 124.371 343.824 118.986 343.824C113.601 343.824 109.236 339.459 109.236 334.074ZM118.986 251.9C113.601 251.9 109.236 256.265 109.236 261.649C109.236 267.034 113.601 271.399 118.986 271.399C124.371 271.399 128.736 267.034 128.736 261.649C128.736 256.265 124.371 251.9 118.986 251.9Z"
          fill="white"
        />
        <mask
          id="mask0_6561_15473"
          maskType="alpha"
          maskUnits="userSpaceOnUse"
          x="84"
          y="139"
          width="269"
          height="292"
        >
          <path
            d="M84.4023 235.254L218.423 139.432L352.443 235.254V430.261H84.4023V235.254Z"
            fill="#FFFFFF"
          />
        </mask>
        <g mask="url(#mask0_6561_15473)">
          <rect
            x="146.914"
            y="245.029"
            width="115.62"
            height="5.30367"
            fill="#D4D7D9"
          />
          <rect
            x="282.688"
            y="245.029"
            width="48.7938"
            height="5.30367"
            fill="#5CEBA0"
          />
          <rect
            x="146.914"
            y="256.697"
            width="115.62"
            height="5.30367"
            fill="#D4D7D9"
          />
          <rect
            x="147.975"
            y="392.212"
            width="155.928"
            height="1.06073"
            fill="#D4D7D9"
          />
          <rect
            x="147.465"
            y="297.095"
            width="185.307"
            height="5.45019"
            fill="#D4D7D9"
          />
          <rect
            x="129.941"
            y="204.721"
            width="150.624"
            height="5.30367"
            fill="#D4D7D9"
          />
          <rect
            x="147.465"
            y="286.973"
            width="185.307"
            height="5.45019"
            fill="#D4D7D9"
          />
          <rect x="142" y="194" width="125" height="5" fill="#D4D7D9" />
          <rect
            x="147.465"
            y="276.851"
            width="92.6533"
            height="5.45019"
            fill="#D4D7D9"
          />
          <rect x="245" y="277" width="88" height="5" fill="#D4D7D9" />
          <rect
            x="201.01"
            y="184"
            width="48.7938"
            height="5.30367"
            fill="#D4D7D9"
          />
          <rect
            x="147.465"
            y="311.502"
            width="115.233"
            height="5.45019"
            fill="#5CEBA0"
          />
          <rect
            width="43.4901"
            height="5.30367"
            transform="matrix(-1 4.70155e-09 9.83115e-09 1 283.748 219.572)"
            fill="#5CEBA0"
          />
        </g>
        <g filter="url(#filter2_d_6561_15473)">
          <path
            d="M84.0139 235.589L218.322 139.432V235.589H84.0139Z"
            fill="white"
          />
        </g>
        <path
          d="M152.314 440.261C161.794 433.864 168.634 424.499 173.509 414.245C178.771 402.855 182.666 390.869 185.105 378.543C186.624 371.758 187.403 364.824 187.423 357.868C187.462 354.49 187.169 351.117 186.545 347.798C186.394 346.771 186.039 345.786 185.5 344.902C184.961 344.018 184.251 343.254 183.412 342.656C178.597 339.886 175.07 346.559 173.752 350.094C171.566 355.595 171.112 361.645 172.45 367.417C172.986 369.843 174.238 372.048 176.04 373.737C177.844 375.427 180.116 376.521 182.548 376.875C188.77 377.655 193.826 373.049 197.961 368.978L196.34 368.305C196.505 377.334 192.222 385.444 188.044 393.142L189.677 394.106C192.024 389.29 195.088 384.866 198.763 380.991H197.428C199.745 383.608 200.11 387.312 201.728 390.326C202.415 391.781 203.588 392.943 205.041 393.605C206.494 394.266 208.131 394.384 209.662 393.938C214.054 392.805 216.565 388.291 220.864 387.112C225.164 385.934 228.783 390.173 232.461 391.918C240.984 395.851 250.372 389.791 258.349 387.143C266.958 384.233 275.994 382.83 285.069 382.996C295.308 383.126 305.311 386.118 313.969 391.642C314.998 392.3 315.954 390.647 314.922 389.989C300.252 380.364 281.891 379.277 265.193 383.225C260.943 384.226 256.772 385.546 252.715 387.174C248.176 388.98 243.436 391.229 238.473 391.26C235.998 391.259 233.575 390.543 231.491 389.194C229.835 388.014 228.109 386.931 226.331 385.949C222.653 384.19 219.26 385.215 216.125 387.587C212.66 390.204 207.043 395.33 203.65 389.699C201.728 386.439 201.442 382.506 198.851 379.583C198.674 379.411 198.434 379.315 198.187 379.315C197.938 379.315 197.701 379.411 197.52 379.583C193.711 383.573 190.529 388.13 188.09 393.096C187.561 394.198 189.135 395.147 189.723 394.06C194.069 386.057 198.46 377.624 198.276 368.259C198.273 368.074 198.214 367.894 198.109 367.742C198.003 367.589 197.859 367.47 197.691 367.399C197.52 367.328 197.333 367.308 197.155 367.341C196.975 367.374 196.807 367.459 196.672 367.585C193.237 370.968 189.102 374.992 184.001 375.008C181.798 374.971 179.669 374.201 177.943 372.818C176.214 371.435 174.988 369.515 174.449 367.356C173.124 362.119 173.413 356.598 175.28 351.532C175.885 349.17 177.055 346.995 178.689 345.197C181.246 342.871 183.639 344.523 184.5 347.37C185.177 350.091 185.506 352.889 185.486 355.695C185.611 358.813 185.539 361.936 185.273 365.045C184.698 371.208 183.629 377.313 182.078 383.302C179.724 393.52 176.355 403.471 172.026 413.006C167.257 423.014 160.643 432.349 151.436 438.608C150.424 439.281 151.436 440.95 152.39 440.261H152.314Z"
          fill="#222222"
        />
      </g>
      <path d="M232.778 27L251 14H196V27L232.778 27Z" fill="#05AAC0" />
      <path d="M196 27L233 53V27H196Z" fill="#B0E4EB" />
      <line
        x1="24"
        y1="86.2573"
        x2="133"
        y2="86.2573"
        stroke="#B3B9BD"
        strokeWidth="3.60938"
      />
      <line
        x1="23.8691"
        y1="103.722"
        x2="104.512"
        y2="103.722"
        stroke="#5CEBA0"
        strokeWidth="3.60938"
      />
      <line
        x1="114.852"
        y1="103.722"
        x2="152.071"
        y2="103.722"
        stroke="#FCE969"
        strokeWidth="3.60938"
      />
      <line
        x1="23.8691"
        y1="121.209"
        x2="168.612"
        y2="121.209"
        stroke="#B3B9BD"
        strokeWidth="3.60938"
      />
      <line
        x1="23.8691"
        y1="156.18"
        x2="90.0375"
        y2="156.18"
        stroke="#FCE969"
        strokeWidth="3.60938"
      />
      <line
        x1="100.377"
        y1="156.18"
        x2="150.003"
        y2="156.18"
        stroke="#5CEBA0"
        strokeWidth="3.60938"
      />
      <line
        x1="23.8691"
        y1="173.666"
        x2="131.393"
        y2="173.666"
        stroke="#FD7A7D"
        strokeWidth="3.60938"
      />
      <line
        x1="23.8691"
        y1="138.694"
        x2="137.596"
        y2="138.694"
        stroke="#B3B9BD"
        strokeWidth="3.60938"
      />
      <line
        x1="23.8691"
        y1="192.179"
        x2="98.3085"
        y2="192.179"
        stroke="#B3B9BD"
        strokeWidth="3.60938"
      />
      <line
        x1="23.8691"
        y1="209.281"
        x2="65.2243"
        y2="209.281"
        stroke="#5CEBA0"
        strokeWidth="3.60938"
      />
      <g mixBlendMode="multiply">
        <rect
          x="279.349"
          y="240.629"
          width="55.4745"
          height="13.9384"
          fill="#ABF6CF"
        />
        <rect
          x="279.349"
          y="240.629"
          width="55.4745"
          height="13.9384"
          stroke="#1D1F21"
          strokeWidth="1.06073"
        />
      </g>
      <rect
        x="335.354"
        y="255.098"
        width="4.61512"
        height="4.61512"
        fill="#1D1F21"
      />
      <rect
        x="335.354"
        y="235.483"
        width="4.61512"
        height="4.61512"
        fill="#1D1F21"
      />
      <rect
        x="274.203"
        y="255.098"
        width="4.61512"
        height="4.61512"
        fill="#1D1F21"
      />
      <rect
        x="274.203"
        y="235.483"
        width="4.61512"
        height="4.61512"
        fill="#1D1F21"
      />
      <g mixBlendMode="multiply">
        <rect
          x="143.2"
          y="307.083"
          width="131.531"
          height="13.7895"
          fill="#ABF6CF"
        />
        <rect
          x="143.2"
          y="307.083"
          width="131.531"
          height="13.7895"
          stroke="#1D1F21"
          strokeWidth="1.06073"
        />
      </g>
      <rect
        x="274.201"
        y="320.342"
        width="4.61512"
        height="4.61512"
        fill="#1D1F21"
      />
      <rect
        x="274.201"
        y="302.309"
        width="4.61512"
        height="4.61512"
        fill="#1D1F21"
      />
      <rect
        x="138.428"
        y="320.342"
        width="4.61512"
        height="4.61512"
        fill="#1D1F21"
      />
      <rect
        x="138.428"
        y="302.309"
        width="4.61512"
        height="4.61512"
        fill="#1D1F21"
      />
      <g mixBlendMode="multiply">
        <rect
          x="233.737"
          y="215.171"
          width="55.4745"
          height="13.9384"
          fill="#ABF6CF"
        />
        <rect
          x="233.737"
          y="215.171"
          width="55.4745"
          height="13.9384"
          stroke="#1D1F21"
          strokeWidth="1.06073"
        />
      </g>
      <rect
        x="289.742"
        y="229.64"
        width="4.61512"
        height="4.61512"
        fill="#1D1F21"
      />
      <rect
        x="289.742"
        y="210.025"
        width="4.61512"
        height="4.61512"
        fill="#1D1F21"
      />
      <rect
        x="228.592"
        y="229.64"
        width="4.61512"
        height="4.61512"
        fill="#1D1F21"
      />
      <rect
        x="228.592"
        y="210.025"
        width="4.61512"
        height="4.61512"
        fill="#1D1F21"
      />
      <path
        d="M158 377.017L149.157 367L131 367L131 387L149.157 387L158 377.017Z"
        fill="#F0D738"
      />
      <g clipPath="url(#clip0_6561_15473)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M141.273 378.798C141.627 379.199 142.095 379.425 142.557 379.425L142.57 379.412C142.63 379.412 142.69 379.406 142.751 379.399C143.396 379.313 143.781 378.85 144.068 378.507L144.081 378.49C144.101 378.467 144.122 378.441 144.144 378.414C144.254 378.28 144.389 378.115 144.422 378.089C144.424 378.09 144.426 378.092 144.429 378.094C144.439 378.102 144.457 378.116 144.483 378.145C144.549 378.227 144.61 378.308 144.663 378.396C144.669 378.405 144.675 378.414 144.681 378.423C144.784 378.573 144.9 378.744 145.064 378.904C145.633 379.443 146.395 379.519 147.057 379.098C147.398 378.879 147.699 378.566 148 378.102L146.856 377.449C146.663 377.75 146.475 377.951 146.301 378.064C146.181 378.145 146.141 378.152 146.014 378.033C145.96 377.982 145.91 377.908 145.855 377.828C145.835 377.798 145.815 377.768 145.793 377.738C145.706 377.606 145.613 377.481 145.512 377.362C145.258 377.067 144.944 376.891 144.596 376.86C143.794 376.791 143.326 377.355 143.018 377.732C142.878 377.907 142.677 378.152 142.563 378.164C142.537 378.164 142.43 378.127 142.316 377.995C142.048 377.688 141.808 377.299 141.574 376.91C141.467 376.735 141.286 376.622 141.072 376.597C140.858 376.572 140.651 376.647 140.504 376.791C140.049 377.249 139.507 377.707 139.006 377.644C138.832 377.619 138.645 377.562 138.457 377.468C138.474 377.446 138.492 377.424 138.511 377.402C138.529 377.38 138.548 377.359 138.564 377.337C139.307 376.39 139.694 375.249 139.648 374.126C139.587 372.628 138.671 371.625 137.361 371.625C136.424 371.625 135.716 372.032 135.368 372.778C134.672 374.245 135.548 376.597 136.424 377.518C135.976 377.794 135.488 378.014 135 378.214L135.528 379.362C136.184 379.092 136.846 378.791 137.448 378.371C137.902 378.666 138.357 378.835 138.825 378.892C139.641 378.992 140.33 378.622 140.831 378.227C140.965 378.421 141.112 378.616 141.273 378.798ZM136.592 373.286C136.685 373.085 136.852 372.879 137.361 372.879V372.872C138.217 372.872 138.303 373.951 138.31 374.17C138.344 375.01 138.049 375.869 137.488 376.59L137.427 376.666C136.812 376.026 136.164 374.189 136.592 373.286ZM148 380.725H135V382.025H148V380.725Z"
          fill="#1D1F21"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_6561_15473"
          x="69.0137"
          y="128.432"
          width="366.646"
          height="330.993"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6561_15473"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6561_15473"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_6561_15473"
          x="176.767"
          y="191.598"
          width="61.3092"
          height="62.0871"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.01399" />
          <feGaussianBlur stdDeviation="1.507" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6561_15473"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6561_15473"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_6561_15473"
          x="72.7112"
          y="131.143"
          width="156.914"
          height="118.762"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.01399" />
          <feGaussianBlur stdDeviation="5.65123" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6561_15473"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6561_15473"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_6561_15473">
          <rect
            width="13"
            height="13"
            fill="white"
            transform="translate(135 370)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default HeroAsset
